import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { get } from '../../helpers/apiHelper';
import EmbeddedRegistrationForm from '../../components/embedded/EmbeddedRegistrationForm';

const EmbedFormPage = () => {
    const { embedCode } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [config, setConfig] = useState(null);

    useEffect(() => {
        const loadEmbedConfig = async () => {
            try {
                setLoading(true);

                // Intentar cargar configuración del backend
                try {
                    const configData = await get(`embed/public/${embedCode}`);
                    setConfig(configData);
                } catch (backendError) {
                    console.warn('Backend no disponible, usando configuración por defecto');
                    // Configuración por defecto si el backend no está disponible
                    setConfig({
                        customStyles: {
                            primaryColor: '#3B82F6',
                            backgroundColor: 'transparent',
                            textColor: '#1F2937',
                            borderRadius: '8px',
                            fontFamily: 'system-ui, sans-serif',
                            showHeader: true,
                            showBenefits: true
                        }
                    });
                }
            } catch (error) {
                console.error('Error loading embed config:', error);
                setError('Error al cargar la configuración del formulario');
            } finally {
                setLoading(false);
            }
        };

        if (embedCode) {
            loadEmbedConfig();
        } else {
            setError('Código de embed no válido');
            setLoading(false);
        }
    }, [embedCode]);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                backgroundColor: 'transparent'
            }}>
                <div style={{
                    textAlign: 'center',
                    color: '#6B7280',
                    fontSize: '14px'
                }}>
                    Cargando formulario...
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                backgroundColor: 'transparent'
            }}>
                <div style={{
                    textAlign: 'center',
                    color: '#EF4444',
                    fontSize: '14px'
                }}>
                    {error}
                </div>
            </div>
        );
    }

    return (
        <div style={{
            backgroundColor: 'transparent',
            minHeight: '100vh',
            padding: '0',
            margin: '0',
            fontFamily: 'system-ui, sans-serif'
        }}>
            <EmbeddedRegistrationForm
                embedCode={embedCode}
                customStyles={config?.customStyles || {}}
                theme="minimal"
                onSuccess={(result) => {
                    console.log('Registro exitoso:', result);
                    // Enviar mensaje al parent window si está en iframe
                    if (window.parent !== window) {
                        window.parent.postMessage({
                            type: 'petitshop:success',
                            data: result
                        }, '*');
                    }
                }}
                onError={(error) => {
                    console.error('Error en registro:', error);
                    // Enviar mensaje al parent window si está en iframe
                    if (window.parent !== window) {
                        window.parent.postMessage({
                            type: 'petitshop:error',
                            data: error
                        }, '*');
                    }
                }}
                showHeader={config?.customStyles?.showHeader !== false}
                showBenefits={config?.customStyles?.showBenefits !== false}
                className="embed-form-page"
            />
        </div>
    );
};

export default EmbedFormPage;
